// An https URL on an HP host. http: and javascript: are refused even when the host matches.
export const isHPUrl = (url: string) => {
  try {
    const { protocol, host } = new URL(url)
    return protocol === 'https:' && host.endsWith('.hp.com')
  } catch (err: unknown) {}

  return false
}
